import { FC } from 'react'
import { formatDateTime } from '../../../../../_metronic/helpers'
import { DetailField, DetailFields, DetailHeader, DetailPanel } from '../../../../components'

/** Linha da prévia: as 17 células do Anexo II na ordem do `cabecalho`. */
export type LinhaAnexo = { id: number; celulas: string[] }

/** Posição das colunas no Anexo II (17 colunas fixas do edital, mesma ordem do backend). */
export const COLUNA_ANEXO_II = {
  identificador: 1,
  especialidade: 10,
  solicitacao: 11,
  resposta: 12,
  situacao: 13,
  intencaoEncaminhar: 14,
  encaminhamentoEvitado: 15,
  satisfacao: 16,
} as const

const DATAS: number[] = [COLUNA_ANEXO_II.solicitacao, COLUNA_ANEXO_II.resposta]
const SIM_NAO: number[] = [
  COLUNA_ANEXO_II.intencaoEncaminhar,
  COLUNA_ANEXO_II.encaminhamentoEvitado,
]
const ROTULO_SIM_NAO: Record<string, string> = { '0': 'Não', '1': 'Sim', '2': 'Não informado' }

/**
 * Valor exibido de uma célula: datas legíveis e os códigos do edital com o significado ao lado
 * ("1 · Sim"), sem esconder o valor que vai no arquivo.
 */
export const valorCelulaAnexoIi = (coluna: number, valor?: string): string | undefined => {
  if (!valor) return undefined
  if (DATAS.includes(coluna)) return formatDateTime(valor)
  if (SIM_NAO.includes(coluna) && ROTULO_SIM_NAO[valor])
    return `${valor} · ${ROTULO_SIM_NAO[valor]}`
  if (coluna === COLUNA_ANEXO_II.satisfacao && valor === '0') return '0 · Não avaliado'
  return valor
}

type Props = {
  data?: LinhaAnexo
  cabecalho: string[]
}

/** Todas as 17 colunas da linha do Anexo II, com o rótulo oficial do cabeçalho. */
export const RelatorioMensalExpandedRow: FC<Props> = ({ data, cabecalho }) => {
  if (!data) return null

  return (
    <DetailPanel>
      <DetailHeader
        title={data.celulas[COLUNA_ANEXO_II.identificador] || 'Teleconsultoria'}
        meta={[data.celulas[COLUNA_ANEXO_II.especialidade]]}
      />
      <DetailFields>
        {cabecalho.map((rotulo, coluna) => (
          <DetailField
            key={coluna}
            label={rotulo}
            value={valorCelulaAnexoIi(coluna, data.celulas[coluna])}
            emptyLabel='Vazio no relatório'
            wide={rotulo.length > 60}
          />
        ))}
      </DetailFields>
    </DetailPanel>
  )
}
